




import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import SignedTextView from '@/modules/shared/components/shared/SignedTextView.vue'
import ActiveInactiveStatusView from '@/modules/shared/components/shared/ActiveInactiveStatusView.vue'
import { AdminVipGroupRoute } from '@/modules/vip-group/routes/admin-vip-group.route'
import AdminVipGroupActions from '@/modules/vip-group/components/admin/table/AdminVipGroupActions.vue'
import EllipsisLink from '@/modules/shared/components/shared/utils/EllipsLink.vue'

@Component({
  components: {
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped,
    BaseTooltip
  }
})
export default class AdminVipGroupTableRow extends mixins<TesTableRow>(TesTableRow) {
  constructor(
    private readonly routes: AdminVipGroupRoute
  ) {
    super()
  }

  columnComponents = {
    title: {
      component: EllipsisLink,
      handler: (value, row) => ({ href: this.routes.show(row.id), text: row.title })
    },
    percent: {
      component: SignedTextView,
      handler: (value) => ({ value: value, ltr: true })
    },
    active: {
      component: ActiveInactiveStatusView,
      handler: (value) => ({ status: value })
    },
    actions: {
      component: AdminVipGroupActions,
      handler: (value, row) => ({ vipGroup: row })
    }
  }

}
